// document.addEventListener('DOMContentLoaded', () => {
//   const section = document.querySelector(".wt-product__main");
//   let doChangeSubs = false;
//   const dataProductType = section.dataset.productType;
//   console.log(dataProductType);
//   if(dataProductType == 'RUBS'){
//     doChangeSubs = true;
//   }
//   document.querySelectorAll(".shopify_subscriptions_app_block").forEach((el) => {
//     const label = el.querySelector(".shopify_subscriptions_app_block_label_children > li > label");
//     const input = el.querySelector(".shopify_subscriptions_app_block_label_children > li > label > input");
//     if(doChangeSubs){
//       input.click();
//     }
//     label.childNodes.forEach(node => {
//         if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
//             node.textContent = 'Subscribe and Save 10% (Monthly Delivery)'; // write custom subscription text here
//         }
//     })
//   })
// });

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(".shopify_subscriptions_app_block").forEach((el) => {
    const label = el.querySelector(".shopify_subscriptions_app_block_label_children > li > label");
    const input = el.querySelector(".shopify_subscriptions_app_block_label_children > li > label > input");
    label.childNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
            node.textContent = 'Subscribe and Save 10% (Monthly Delivery)'; // write custom subscription text here
        }
    })
  })
});